import { RotatingLines } from 'react-loader-spinner';
import React from 'react';

const Loading = ({
    width = "60",
    height = "60",
}) => {
    return (
            <RotatingLines
                visible={true}
                height={width}
                width={height}
                color="grey"
                strokeWidth="5"
                animationDuration="1.4"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass="" 
            />
    );
}

export default Loading;